import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Container } from '@pella/sash-framework';
import { Layout, SEO, Breadcrumbs } from '../../components';
import { useBranchShowrooms } from '../../hooks/use-branch-showrooms';
import { isValidArray } from '../../components/utilities/validations';

import DynamicComponent from '../../components/common/dynamic-component';
import CardSection from '../../components/common/card-section';
import NearbyShowrooms from '../../components/template/branch-showroom/nearby-showrooms';
import LocalNavTop from '../../components/common/local-nav-top';
import BranchCollectionSD from '../../components/common/structured-data/branch-collection';

const BranchListing = (props) => {
	const pageData = props.data.contentstackBranchListing;
	const branchData = isValidArray(pageData.branch_data) ? pageData.branch_data[0] : {};
	const combinedShowrooms = [...props.data.showroomsByBranch?.nodes, ...props.data.showroomsByStoreNumber?.nodes];
	const { showrooms, error } = useBranchShowrooms(branchData?.branch_retail, combinedShowrooms, branchData?.additional_showrooms);

	return (
		<Layout id='template-BranchListing'>
			{isValidArray(branchData?.local_nav) && (
				<LocalNavTop
					branchData={branchData}
					linksArray={branchData.local_nav}
					isAnchors={false}
					currentUrl={pageData.url}
				/>
			)}
			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}
			<Container>
				<h1>{pageData.heading}</h1>

				<NearbyShowrooms
					locations={showrooms.filter((showroom) => (branchData?.by_state ? showroom.state === branchData?.state?.abbreviation : true))}
					error={error}
					className='my-8 md:flex-row-reverse xl:my-12'
					key={showrooms?.length}
				/>
			</Container>

			{isValidArray(pageData.modular_blocks) &&
				pageData.modular_blocks.map((block, index) => {
					if (isValidArray(block.dynamic?.dynamic)) {
						return (
							<DynamicComponent
								key={index}
								data={block.dynamic}
								className='border-b border-b-gray-15 bg-gray-5 py-6 xl:py-8'
							/>
						);
					}

					if (isValidArray(block.cards?.cards)) {
						return (
							<CardSection
								key={index}
								data={block.cards}
							/>
						);
					}
				})}

			<BranchCollectionSD
				branchData={branchData}
				description={pageData.seo.description}
				url={pageData.url}
				showrooms={isValidArray(showrooms) ? showrooms.filter((showroom) => (branchData?.by_state ? showroom.state === branchData?.state?.abbreviation : true)) : []}
			/>
		</Layout>
	);
};

BranchListing.propTypes = {
	data: PropTypes.object,
	location: PropTypes.object,
};

export default BranchListing;

// eslint-disable-next-line react/prop-types -- gatsby component
export const Head = ({ data }) => <SEO {...data.contentstackBranchListing.seo} />;

export const query = graphql`
	query ($uid: String!, $branch_id: [String], $store_numbers: [String]) {
		contentstackBranchListing(id: { eq: $uid }) {
			url
			breadcrumbs {
				active_page
				back_pages {
					...CTA
				}
			}
			branch_data {
				...BranchData
			}
			heading
			by_state
			modular_blocks {
				dynamic {
					heading
					description
					cta {
						...CTA
					}
					dynamic {
						...Dynamic
					}
				}
				cards {
					...CardSection
				}
			}
			seo {
				...SEO
			}
		}

		showroomsByBranch: allShowrooms(filter: { branch_id: { in: $branch_id } }) {
			nodes {
				...Showroom
			}
		}

		showroomsByStoreNumber: allShowrooms(filter: { store_number: { in: $store_numbers } }) {
			nodes {
				...Showroom
			}
		}
	}
`;
